import React from 'react';
import ReactDOM from 'react-dom';
import { FaTimes } from 'react-icons/fa';
import styles from './modals.module.css';

export const AddZoomModal = ({
  isOpen,
  onClose,
  image,
  zoomThumbnail,
  onAddZoomAreas
}) => {
  if (!isOpen || !image) return null;

  return ReactDOM.createPortal(
    <div className={styles.removeBgModalOverlay} onClick={onClose}>
      <div className={styles.addZoomModal} onClick={(e) => e.stopPropagation()}>
        <button type="button" className={styles.addZoomModalClose} onClick={onClose} aria-label="Close">
          <FaTimes />
        </button>

        <div className={styles.addZoomModalImages}>
          <div className={styles.addZoomModalImageBox}>
            <img src={image?.previewUrl || ''} alt="Source image" className={styles.addZoomModalImage} />
          </div>
          <div className={styles.addZoomModalArrow}>
            <svg width="40" height="24" viewBox="0 0 40 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 12H38M38 12L28 2M38 12L28 22" stroke="#78B3F3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div className={styles.addZoomModalImageBox}>
            {zoomThumbnail
              ? <img src={zoomThumbnail} alt="Zoom template" className={styles.addZoomModalImage} />
              : <div className={styles.addZoomModalPlaceholder}><span className={styles.addZoomModalPlaceholderText}>Zoom preview placeholder</span></div>
            }
          </div>
        </div>

        <h2 className={styles.addZoomModalTitle}>Add Zoom to the Image</h2>
        <p className={styles.addZoomModalInstructions}>Select the areas to zoom into the image</p>

        <div className={styles.addZoomModalActions}>
          <button type="button" className={styles.addZoomModalPrimaryButton} onClick={onAddZoomAreas}>
            Add Zoom Areas
          </button>
          <button type="button" className={styles.addZoomModalBackLink} onClick={onClose}>
            Go back to the listing
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};
